import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class DailyRunRateServices {
  createDailyRunRate = async (payload) => {
    const drr = await Helpers.post({
      url: Constants.DAILY_RUN_RATE,
      data: payload,
    });
    return drr;
  }

  updateDailyRunRate = async (payload) => {
    const drr = await Helpers.put({
      url: Constants.DAILY_RUN_RATE,
      data: payload,
    });
    return drr;
  }

  deleteDailyRunRate = async (payload) => {
    const drr = await Helpers.delete({
      url: Constants.DAILY_RUN_RATE,
      data: payload,
    });
    return drr;
  }

  pinDailyRunRate = async (payload) => {
    const drr = await Helpers.put({
      url: `${Constants.DAILY_RUN_RATE}/pin`,
      data: payload,
    });
    return drr;
  }

  getDailyRunRates = async (tenantId, drrId, page, limit, searchKeyword) => {
    let url = `${Constants.DAILY_RUN_RATE}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (drrId) url += `drr_id=${drrId}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;

    const drr = await Helpers.get({ url });
    return drr;
  }
}

export default new DailyRunRateServices();